import 'angular:locale/data:zh';
import 'angular:locale/data:fr';
import 'angular:locale/data:it';
import 'angular:locale/data:de';
import 'angular:locale/data:es';
import 'angular:locale/data:en';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
